/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useContext } from 'react';
const HabitatContext = createContext({});
/**
 * Component to provide access to habitat props.
 * @param props
 */
export const HabitatProvider = ({ children, habitat }) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { proxy, ...otherProps } = habitat;
    return React.createElement(HabitatContext.Provider, { value: otherProps }, children);
};
/**
 * Hook to provide access to habitat props.
 */
export function useHabitat() {
    return useContext(HabitatContext);
}
/**
 * HOC to provide access to habitat props.
 */
export function withHabitat(WrappedComponent) {
    const WithHabitat = (props) => (React.createElement(HabitatContext.Consumer, null, (habitat) => React.createElement(WrappedComponent, Object.assign({}, habitat, props))));
    WithHabitat.displayName = getDisplayName(WrappedComponent);
    return WithHabitat;
}
/** Get the display name for the component. */
function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
